var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppBarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3498DB;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(9.6) translate(10, 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1199",
    transform: "matrix(1.3227513227513228,0,0,1.3227513227513228,121,59.269848132259625)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-64.5-16.2l2.7-4.7l8.2,14h5.4c-1.2-1.9-12.6-21.4-13.6-23.3L-73.6-9.8L-78-2.2h-16.2 c0.9-1.5,7-12.1,12.8-22.2c3.4-5.9,7.2-12.6,11.5-19.9h5.4l-11.2,19.3L-86.1-6.9h5.4c7.4-13,12-20.7,18.8-32.7 c0.4,0.7,21.5,37.3,21.7,37.4h-16.2L-64.5-16.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppBarLogo);
export default __webpack_public_path__ + "static/media/app-bar-logo.fb2500e736c3e2d487c3f2aa52c03b8d.svg";
export { ForwardRef as ReactComponent };